import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography } from 'antd';
import MobileHeader from '../../../components/mobile/Header';
import { ReactComponent as DoctorSvg } from '../../../assets/icons/doctor.svg';
import { ReactComponent as AppointmentSvg } from '../../../assets/icons/appointment.svg';
import { ReactComponent as KnowledgeBankSvg } from '../../../assets/icons/knowledge-bank.svg';
import { ReactComponent as MedicalRecordSvg } from '../../../assets/icons/medical-record.svg';
import { ReactComponent as SendFileSvg } from '../../../assets/icons/send-file.svg';

const { Title } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '400',
    fontSize: '20px',
    margin: 0
  },
  subtitle: {
    color: '#15A9E1',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '300'
  },
  itemTitle: {
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'center',
    fontWeight: '400',
    color: '#404047',
    marginBottom: 0
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12,
    minHeight: 170
  },
  circle: {
    width: 85,
    height: 85,
    backgroundColor: '#E7E7E7',
    borderRadius: '50%',
    margin: '0 auto',
    marginBottom: 5
  },
  link: {
    fontSize: 12,
    fontWeight: '400',
    display: 'flex',
    justifyContent: 'center'
  },
  boxSend: {
    width: '100%',
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "27px 36px",
    gap: "20px",
    height: "104px",
    background: "#FFFFFF",
    border: "1px solid #EAEAEA",
    borderRadius: "5px",
    marginTop: 55,
    cursor: 'pointer'
  },
  sendFileText: {
    fontWeight: "400",
    fontSize: "15px",
    lineHeight: "22px",
    textAlign: "center",
    color: "#404047",
    marginBottom: 0
  }
};

const data = [
  {name: 'Speak to a Doctor', icon: <DoctorSvg />, url: '/speak-doctor'},
  {name: 'Knowledge Bank', icon: <KnowledgeBankSvg />, url: '/knowledge-bank'},
  {name: 'Appointments', icon: <AppointmentSvg />, url: '/appointment'},
  {name: 'Medical Records', icon: <MedicalRecordSvg />, view: '/medical-history'},
];

function MobileHomeScreen() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();

  const renderAvatar = (item) => {
    return (
      <Col xs={12}>
        <Box paddingY={12} paddingX={18} style={styles.box}>
          {
            item.icon !== null
            ? (
              <Box textAlign="center">
                {item.icon}
              </Box>
            )
            : (
              <Box style={styles.circle} />
            )
          }
          <Title level={4} style={styles.itemTitle} onClick={() => history.push(item.url)}>
            {item.name}
          </Title>
          {
            item.view !== undefined && <Link to={item.view} style={styles.link}>{t('welcome:login.link')}</Link>
          }
        </Box>
      </Col>
    )
  }

  return (
    <>
      <MobileHeader />
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <Col>
            <Title level={4} style={styles.title}>
              {t('welcome:login.greeting')} Sue.
            </Title>
            <p style={styles.subtitle}>
              {t('welcome:login.whatYouTodo')}
            </p>
          </Col>
        </Row>
        <Row>
          {data.map((item) => renderAvatar(item))}
        </Row>
        <Box style={styles.boxSend} onClick={() => history.push("/send-doctor")}>
          <SendFileSvg />
          <Title level={4} style={styles.sendFileText}>
            {t('welcome:sendFileDoctor')}
          </Title>
        </Box>
      </Box>
    </>
  );
}

export default MobileHomeScreen;
